import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { rpc, useSession } from "@vixio/data";
import { HelpButton, type HelpTopic } from "@vixio/ui";
import "./api";

/** Botão de ajuda contextual na barra superior (ModuleUi.topbar): usa a rota atual. */
export function HelpTopbar() {
  const session = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  const orgId = session.org?.id ?? null;
  const load = useCallback((route: string) => rpc("help", "get_bundle", { p_org: orgId!, p_route: route }), [orgId]);
  const search = useCallback(async (q: string) => rpc("help", "search", { p_org: orgId!, p_q: q, p_limit: 12 }), [orgId]);
  const feedback = useCallback(
    (t: HelpTopic, helpful: boolean) => rpc("help", "record_feedback", { p_org: orgId!, p_topic: t.id, p_helpful: helpful, p_route: location.pathname }),
    [orgId, location.pathname],
  );
  if (!orgId) return null;
  return <HelpButton route={location.pathname} load={load} search={search} onFeedback={feedback} onOpenCenter={() => navigate("/configuracoes/ajuda")} />;
}
